import { render, staticRenderFns } from "./KsLoadingSplash.vue?vue&type=template&id=653c4be2&scoped=true"
import script from "./KsLoadingSplash.vue?vue&type=script&lang=js"
export * from "./KsLoadingSplash.vue?vue&type=script&lang=js"
import style0 from "./KsLoadingSplash.vue?vue&type=style&index=0&id=653c4be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653c4be2",
  null
  
)

export default component.exports